import { render } from 'react-dom';
import { createRoot } from 'react-dom/client';
import toSpliced from 'core-js-pure/actual/array/virtual/to-spliced';

import 'react-tooltip/dist/react-tooltip.css';

import { config as typingConfig } from '@jurinfor/typing';

import './js/makeContext'; // set context of external functions
import './js/populateWindow'; // add functions to window
import './js/framework/initHintProcType'; // declare new process types

import Main from './ui/Main';

import jQuery from 'jquery';
window.jQuery = jQuery; // for bootstrap

typingConfig.teeIdError = false;

Array.prototype.toSpliced = toSpliced;

const root = createRoot(document.getElementById('root'))

root.render(Main());
